import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';

export default function AlertDialog({open, setOpen, success}) {

    const navigate = useNavigate();

  const handleClose = () => {
    if(success){
        setOpen(false);
        navigate("/");
        window.location.reload();
    }
    else{
        setOpen(false);
    }
  };

  return (
    <React.Fragment>
        {success ? 
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Success
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your quote submitted successfully. Thank you.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      :
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Failed
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your quote is not Submitted. Please fill all required fields.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
        }
    </React.Fragment>
  );
}